var JourneyVariant = /* @__PURE__ */ ((JourneyVariant2) => {
  JourneyVariant2["JBL"] = "jbl";
  JourneyVariant2["STANDARD_UNIT_LISTING"] = "standard-unit-listing";
  return JourneyVariant2;
})(JourneyVariant || {});
export {
  JourneyVariant
};
//# sourceMappingURL=Journey.mjs.map